module.exports = __webpack_public_path__ + "static/media/harrison-photo.fdc12a43.png";